import { isAuth } from '../utils/tokenServices.ts';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import ShadowComponent from './ShadowComponent.tsx';

export const FooterComponent = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'footer' });
  const isAuthenticated = isAuth();

  return (
    <footer className="framework-footer">
      <div className="left-side">
        <span>{t('companyName', { year: new Date().getFullYear() })}</span>
      </div>
      <div className={cn('right-side', { 'row-menu': isAuthenticated })}>
        {isAuthenticated ? (
          <a href="/terms">{t('terms')}</a>
        ) : (
          <a href="https://www.infineon.com/cms/en/about-infineon/usage-terms/" target="_blank" rel="noreferrer">
            {t('nonAuthTerms')}
          </a>
        )}
        <a href="https://www.infineon.com/cms/en/about-infineon/imprint/" target="_blank" rel="noreferrer">
          {t('imprint')}
        </a>
        <a href="https://www.infineon.com/cms/en/about-infineon/privacy-policy/" target="_blank" rel="noreferrer">
          {t('privacy')}
        </a>
        <a
          href="https://www.infineon.com/cms/en/about-infineon/press/general-information/glossary/"
          target="_blank"
          rel="noreferrer"
        >
          {t('glossary')}
        </a>
      </div>
    </footer>
  );
};

const Footer = () => {
  return (
    <ShadowComponent>
      <FooterComponent />
    </ShadowComponent>
  );
};

export default Footer;
